// BARCINO - Pages annexes (mentions, CGV, confidentialité, livraison) :
// toggle des accordéons FAQ. Le clic natif sur <summary> est intercepté par le
// handler de navigation global de Barba (tout clic hors lien reconnu est
// preventDefault), donc le toggle natif de <details> ne se déclenche jamais
// sur une page barba-container — on le ré-implémente en JS, comme barcino_faq.js.
const barcinoLegal = {
    _handlers: [],

    init() {
        this.destroy();

        document.querySelectorAll('.bc-legal-faq .bc-faq-accordion > summary').forEach((summary) => {
            const handler = (event) => {
                const details = summary.parentElement;
                if (!details || details.tagName !== 'DETAILS') return;
                event.preventDefault();
                details.open = !details.open;
            };
            summary.addEventListener('click', handler);
            this._handlers.push({ el: summary, fn: handler });
        });
    },

    destroy() {
        this._handlers.forEach(({ el, fn }) => el.removeEventListener('click', fn));
        this._handlers = [];
    },
};

export default barcinoLegal;
